import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiWindow {
    constructor() {

    }

    activateWindow() {
    }

    activeWindow() {
    }

    createWindow() {
    }

    maximizeWindow() {
    }

    minimizeWindow() {
    }

    restoreWindow() {
    }

    setMinWindowSize() {
    }

    setStatusText() {
    }

    windowMaximized() {
    }

    windowMinimized() {
    }
}
